export default __webpack_public_path__ + "06994dd1cdde6bcb25c8de522c2483c3.svg";